import React, { FC, useState, useContext } from 'react';

import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';

import ErrorMessage from '../../../sharedModules/layout/ErrorMessage';
import LoadingWrapper from '../../../sharedModules/layout/LoadingWrapper';

import { backflowJobItemRequiredFields } from '../../backflowJobLists/constants/requiredFields';
import validateRequiredFields from '../../../utils/validateRequiredFields';

import { AuthenticationContext } from '../../../homeModules/auth/contexts/AuthenticationContext';

import { BackflowJobItem } from '../../model';

import axios from '../../../sharedModules/utils/axios.utils';

interface BeginTestButtonProps {
  backflowJobItem: BackflowJobItem;
  onSuccess: () => void;
}

const BeginTestButton: FC<BeginTestButtonProps> = ({ backflowJobItem, onSuccess }) => {
  const { user } = useContext(AuthenticationContext);

  const [errorMessage, setErrorMessage] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(false);
  const [validationErrors, setValidationErrors] = useState<string>('');

  const handleBeginTest = async () => {
    const validate = validateRequiredFields(backflowJobItem, backflowJobItemRequiredFields);
    setValidationErrors(validate.message);
    if (!validate.isValid) return;

    setLoading(true);

    try {
      const jobItemUpdateData = { user_id: user.id.toString(), status: 'in_progress' };

      await axios.put(`/backflows/backflow_job_items/${backflowJobItem.id}`, jobItemUpdateData);
      setErrorMessage('');
      onSuccess();
    } catch (error) {
      setErrorMessage('Something went wrong beginning the test.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <LoadingWrapper isLoading={loading}>
      <Grid container>
        <Grid item xs={12}>
          <ErrorMessage message={errorMessage || validationErrors} />
        </Grid>
        <Grid item xs={12} style={{ display: 'flex', justifyContent: 'center' }}>
          {user?.id ? (
            <Button variant="contained" onClick={handleBeginTest}>
              Begin Test
            </Button>
          ) : (
            <Typography variant="body1">You must be logged in to begin a test.</Typography>
          )}
        </Grid>
      </Grid>
    </LoadingWrapper>
  );
};

export default BeginTestButton;
